import { APP_VARIANT } from '../../config/setting';
import { AvailableAppVariants } from '../enums';
import { APP_CONFIG } from './themeConfig';

/**
 * @WHITE_LABEL_CHANGES
 */

const themeColorScheme = APP_CONFIG?.[APP_VARIANT]?.colorScheme ?? APP_CONFIG?.[AvailableAppVariants.PulseEnergyLite]?.colorScheme;

export const THEME_COLORS = {
  defaultStatusBar: themeColorScheme.defaultStatusBar,

  // generic
  primaryColor: themeColorScheme.primaryColor,
  primaryBorder: themeColorScheme.primaryBorder,
  primaryDark: themeColorScheme.primaryDark,
  primaryLight: themeColorScheme.primaryLight,
  bgColor: themeColorScheme.bgColor,
  textColor: themeColorScheme.textColor,
  bgDark: themeColorScheme.bgDark,
  bgSecondary: themeColorScheme.bgSecondary,
  borderColor: themeColorScheme.borderColor,
  neutralBorderColor: themeColorScheme.neutralBorderColor,
  inputBorder: themeColorScheme.inputBorder,
  buttonBgColor: themeColorScheme.buttonBgColor,
  buttonBgColor2: themeColorScheme.buttonBgColor2,
  buttonBgColor3: themeColorScheme.buttonBgColor3,
  sectionHeader: themeColorScheme.sectionHeader,
  bgHeader: themeColorScheme.bgHeader,

  subTextColor: themeColorScheme.subTextColor,

  secondaryTextColor: themeColorScheme.secondaryTextColor,

  cardSelectedBorderColor: themeColorScheme.cardSelectedBorderColor,
  cardUnselectedBorderColor: themeColorScheme.cardUnselectedBorderColor,

  // semi-generic
  countBadgeBg: themeColorScheme.countBadgeBg,
  countBadgeText: themeColorScheme.countBadgeText,

  cardUnderlayBgColor: themeColorScheme.cardUnderlayBgColor,

  cardBorderColor: themeColorScheme.cardBorderColor,
  cardSelectedBgColor: themeColorScheme.cardSelectedBgColor,
  cardSelectedBgUnderlayColor: themeColorScheme.cardSelectedBgUnderlayColor,
  cardUnselectedBgColor: themeColorScheme.cardUnselectedBgColor,
  cardSelectedTextColor: themeColorScheme.cardSelectedTextColor,
  cardUnselectedTextColor: themeColorScheme.cardUnselectedTextColor,

  // components
  selectedPaymentMethodNameText: themeColorScheme.selectedPaymentMethodNameText,
  unselectedPaymentMethodNameText: themeColorScheme.unselectedPaymentMethodNameText,

  walletBarAppWalletBgColor: themeColorScheme.walletBarAppWalletBgColor,
  walletBarNonAppWalletBgColor: themeColorScheme.walletBarNonAppWalletBgColor,

  quickFilterItemSelectedBg: themeColorScheme.quickFilterItemSelectedBg,
  quickFilterItemSelectedText: themeColorScheme.quickFilterItemSelectedText,
  quickFilterItemUnselectedText: themeColorScheme.quickFilterItemUnselectedText,

  nearestCSContainerText: themeColorScheme.nearestCSContainerText,
  nearestCSContainerSubText: themeColorScheme.nearestCSContainerSubText,
  nearestCSContainerBg: themeColorScheme.nearestCSContainerBg,

  qrCodeTopHalfBg: themeColorScheme.qrCodeTopHalfBg,
  qrCodeBottomHalfBg: themeColorScheme.qrCodeBottomHalfBg,

  textColorOnDarkBg: themeColorScheme.textColorOnDarkBg,
  // textColorOnLightBg: themeColorScheme.textColorOnLightBg,
};